import { Grid } from "@mui/material";

import { Title } from "../styles/Copy";

export interface CopyProps {
  year?: number;
}

export function Copy({
  year = new Date().getFullYear(),
}: Readonly<CopyProps>) {
  return (
    <Grid container>
      <Grid size={12} marginBottom={2}>
        <Title>
          ©{year} Sul América Companhia de Seguro Saúde - Todos os direitos
          reservados CNPJ: 01.685.053/0001-56 - Registro ANS: 006246 - Rua
          Beatriz Larragoiti Lucas, 121 - Cidade Nova - Rio de Janeiro/RJ - CEP:
          20211-903
        </Title>
      </Grid>
    </Grid>
  );
}

export default Copy;